module.exports = __webpack_public_path__ + "2ac6b8516c13a96e9562d8b4a00b3194.png";